import { z } from "zod";
import { EntityId, EntityKind, Instant, Note } from "./entities";
import { Mutation } from "./mutations";

export const ContentConflict = z.object({
  id: z.string(),
  entityId: EntityId,
  kind: EntityKind,
  mutationId: z.uuid(),
  deviceId: z.string(),
  serverRevision: z.number().int(),
  mutation: Mutation,
  reason: z.enum(["stale_revision", "tombstone"]),
  createdAt: Instant,
});
export type ContentConflict = z.infer<typeof ContentConflict>;
export const NoteRevision = z.object({ note: Note, deviceId: z.string(), createdAt: Instant });
export type NoteRevision = z.infer<typeof NoteRevision>;
